import { Record } from 'immutable';
const TemplateSettingsUpdateStatusRecord = Record({
  error: undefined,
  isUpdating: false,
  lastUpdated: null
});
export default TemplateSettingsUpdateStatusRecord;